export enum BatonCustomQuestionKeys {
  APPLIED_FAFSA = 'appliedFAFSA',
  ATTENDING_SCHOOL = 'attendingSchool',
  COMPLETION_SCHOOL = 'completionSchool',
  CONVICTED_OVER_25 = 'convictedOver25',
  CURRENT_EMPLOYED = 'currentlyEmployed',
  DISABILITY_DOC = 'documents.disabilityDoc',
  DOB_DOC = 'dobDOC',
  DRUG_TEST = 'drugTest',
  EDUCATION_AFTER_HS = 'educationAfterHS',
  ELIGIBLE_BENEFITS = 'eligibleBenefits',
  ELIGIBLE_WIAWIOA = 'eligibleWIAWIOA',
  FAMILY_ASSISTANCE_DOC = 'familyAssistanceDoc',
  FELONY = 'felony',
  FOSTER_CARE = 'fosterCare',
  GRADUATE_HS = 'graduateHS',
  HOMELESS = 'homeless',
  HOUSEHOLD_SALARY = 'householdSalary',
  INCARCERATED = 'incarcerated',
  LAID_OFF_EMPLOYMENT = 'laidOffEmployment',
  LIST_MEMBERS_HOUSE = 'listMembersHouse',
  LIST_PREVIOUS_EMPLOYMENTS = 'listPreviousEmployments',
  LIST_TRAINING_AFTER_HS = 'listTrainingAfterHS',
  LIST_TRAINING_HS = 'listTrainingHS',
  MARRIED = 'married',
  NATURAL_DISASTER = 'naturalDisaster',
  PARENT_GUARDIAN = 'parentGuardian',
  PARENTING = 'parenting',
  PARENTS_UNEMPLOYED = 'parentsUnemployed',
  PARISH = 'parish',
  RECIPIENT_OTHER = 'recipientOther',
  RECIPIENT_SNAP = 'recipientSNAP',
  RECIPIENT_TANF = 'recipientTANF',
  RELATED_DISABILITY = 'relatedDisability',
  REPEAT_GRADE_LEVEL = 'repeatGradeLevel',
  RESIDENCE_DOC = 'residenceDoc',
  SELECTIVE_SERVICE = 'selectiveService',
  SELECTIVE_SERVICE_DOC = 'documents.selectiveServiceDoc',
  SEX_TRAFFICKING = 'sexTrafficking',
  SOCIAL_SECURITY_NUMBER_DOC = 'socialSecurityNumberDoc',
  SPOUSE_MILITARY_STATUS = 'spouseMilitaryStatus',
  SPOUSE_NAME = 'spouseName',
  SPOUSE_OCCUPATION = 'spouseOccupation',
  TRAINING_DOC = 'trainingDoc',
  CITIZENSHIP_DOC = 'citizenshipDOC',
  US_CITIZEN = 'usCitizen',
}
